import { create } from 'zustand';
import { FormValues } from '../types/types';

type FiltersStore = {
  filters: FormValues;
  setFilters: (filters: FormValues) => void;
};

export const useFiltersStore = create<FiltersStore>((set) => ({
  filters: {
    dates: { from: null, to: null },
    status: null,
    regionName: null,
    districtName: null,
    humanHazardClass: [],
    beeHazardClass: [],
  },
  setFilters: (filters) => set({ filters }),
}));